import { jsx as _jsx } from "react/jsx-runtime";
/* BrandGlyph — tenant-aware logo container.
 *
 * If `logoUrl` is provided (typically read from tenants.branding JSONB), renders
 * the image. Otherwise falls back to the abstract glyph (concentric squares /
 * circle) — same shape as the Svelte sibling for visual parity.
 *
 * The brand color comes from --accent (which cascades from --brand-accent
 * when applyTenantBranding() has been called).
 *
 * Contract:
 *   <BrandGlyph size={28} coral logoUrl={tenant.branding?.logoUrl} alt="ACME" />
 */
import { forwardRef } from 'react';
export const BrandGlyph = forwardRef(function BrandGlyph({ size = 28, coral = false, logoUrl, alt = 'Brand', style, ...rest }, ref) {
    // Tenant logo path — short-circuit
    if (logoUrl) {
        const wrapperStyle = {
            width: size,
            height: size,
            display: 'inline-grid',
            placeItems: 'center',
            borderRadius: 'var(--radius-sm)',
            overflow: 'hidden',
            ...style,
        };
        return (_jsx("div", { ref: ref, style: wrapperStyle, ...rest, children: _jsx("img", { src: logoUrl, alt: alt, width: size, height: size, style: { width: '100%', height: '100%', objectFit: 'contain' } }) }));
    }
    // Abstract glyph fallback — outer square + inner circle, mirroring Svelte sibling
    const outerStyle = {
        width: size,
        height: size,
        display: 'inline-grid',
        placeItems: 'center',
        borderRadius: 'var(--radius-sm)',
        border: '1.5px solid',
        borderColor: coral ? 'var(--accent)' : 'var(--ink-primary)',
        background: coral ? 'var(--accent)' : 'transparent',
        ...style,
    };
    const innerDiameter = Math.round(size * 0.43);
    const innerStyle = {
        width: innerDiameter,
        height: innerDiameter,
        borderRadius: '50%',
        border: '1.5px solid',
        borderColor: coral ? 'var(--accent-ink)' : 'var(--ink-primary)',
    };
    return (_jsx("div", { ref: ref, role: "img", "aria-label": alt, style: outerStyle, ...rest, children: _jsx("span", { style: innerStyle }) }));
});
//# sourceMappingURL=BrandGlyph.js.map